import {Grid, type GridColumnIndex} from '@primer/react-brand'

import type {PrimerCards} from '../../../schemas/contentful/contentTypes/primerCards'
import {ContentfulCard} from '../ContentfulCard/ContentfulCard'

/**
 * Uses TypeScript discriminated union to ensure the component accepts either a `component`
 * or a `cards` prop, but not both. This increases the flexibility
 * of this component by supporting either a primerCards entry or a
 * plain array of primerComponentCard entries.
 */
export type ContentfulCardsProps = {className?: string} & (
  | {
      component: PrimerCards
      cards?: never
    }
  | {
      cards: PrimerCards['fields']['cards']
      component?: never
    }
)

export function ContentfulCards({cards, component, className}: ContentfulCardsProps) {
  const collection = component !== undefined ? component.fields.cards : cards

  const desktop = collection.length > 2 ? 4 : 6

  const span: {[key: string]: GridColumnIndex} = {
    xsmall: 12,
    small: 12,
    medium: 6,
    large: desktop,
    xlarge: desktop,
    xxlarge: desktop,
  }

  return (
    <Grid className={className}>
      {collection.map(card => (
        <Grid.Column span={span} key={card.fields.href}>
          <ContentfulCard component={card} className="height-full" />
        </Grid.Column>
      ))}
    </Grid>
  )
}

try{ ContentfulCards.displayName ||= 'ContentfulCards' } catch {}